export default __webpack_public_path__ + "static/media/AppStore.138b17c0.svg";